import { render, staticRenderFns } from "./TheSendTailgatingEmailButton.vue?vue&type=template&id=32124d61&scoped=true&lang=html"
import script from "./TheSendTailgatingEmailButton.vue?vue&type=script&lang=ts"
export * from "./TheSendTailgatingEmailButton.vue?vue&type=script&lang=ts"
import style0 from "./TheSendTailgatingEmailButton.vue?vue&type=style&index=0&id=32124d61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32124d61",
  null
  
)

export default component.exports